import React from 'react';
import { Add } from '@mui/icons-material';
import Tooltip from '../utils/Tooltip';
import './CardTopbar.css';

const CardTopbar = ({ info, equipLabel, onEquip, className = '', equipClassName = '', equipIcon, badge = null }) => {
    const EquipIcon = equipIcon || Add;
    return (
        <div className={`card-topbar ${className}`.trim()}>
            <div className="card-topbar-info">
                {info}
            </div>
            {badge}
            {equipLabel && onEquip && (
                <Tooltip content={equipLabel}>
                    <button
                        type="button"
                        className={`equip-button card-topbar-equip ${equipClassName}`.trim()}
                        onClick={onEquip}
                        aria-label={equipLabel}
                    >
                        <EquipIcon className="card-topbar-equip-icon" fontSize="inherit" />
                    </button>
                </Tooltip>
            )}
        </div>
    );
};

export default CardTopbar;

